import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { buttonTheme } from '../button-theme';

const secondaryBtnWidths = {
  large: 64,
  small: 56,
};

type IconButtonStyleProps = {
  active: boolean;
  size: 'large' | 'small';
};

const MAB_HEIGHTS = {
  large: 40,
  small: 32,
  tiny: 18,
};

const MAB_RADIUS = {
  large: 4,
  small: 4,
  tiny: 4,
};

const iconButtonStyle = ({ active, size }: IconButtonStyleProps) => css`
  width: ${secondaryBtnWidths[size]}px;
  height: ${MAB_HEIGHTS[size]}px;
  background: ${buttonTheme.backgroundColor};
  border-left: 2px solid ${buttonTheme.pressedColor};
  border-top-right-radius: ${MAB_RADIUS[size]}px;
  border-bottom-right-radius: ${MAB_RADIUS[size]}px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing(size === 'large' ? 2 : 1)};
  transition: background 250ms ease-out;

  :hover,
  :focus {
    background: ${buttonTheme.hoverColor};
    outline: none;
    border-top-right-radius: ${MAB_RADIUS[size]}px;
    border-bottom-right-radius: ${MAB_RADIUS[size]}px;
  }

  :active {
    background: ${buttonTheme.pressedColor};
  }

  :disabled {
    background: ${buttonTheme.disabled.backgroundColor};
    border-color: ${theme.colors.neutral30};
    cursor: default;
  }

  > svg {
    color: white;
  }

  ${active && `background: ${buttonTheme.hoverColor};`}
`;

export const MultiActionButtonStyles = {
  multiActionButton: (props: IconButtonStyleProps) => iconButtonStyle(props),
};
